import React, { useEffect, useState } from "react";
import { AccountLayout } from "./accountUi";
import { apiGet } from "../../Utils/apiFetch";
import apiPath from "../../Utils/apiPath";
import obj from "../../Utils/helpers";
import { PageShell, TableCard, thStyle, tdStyle } from "./accountUi";

/* Activity Log — reference kingexch111.com/activity-log.
 * Login Date & Time / Login Status / IP Address. */

const ActivityLogNew = () => {
  const [rows, setRows] = useState([]);

  const fetchData = async () => {
    const { status, data } = await apiGet(apiPath.activityLogs, { page: 1, limit: 100 });
    if (status === 200 && data?.success) {
      const all = data?.results?.data || [];
      setRows(all.filter((a) => (a?.activityStatus || "").toLowerCase().includes("login")));
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <AccountLayout>
      <PageShell>
        <div style={{ padding: "10px 10px 0" }} />
        <TableCard title="Activity Log">
          <div style={{ overflowX: "auto" }}>
            <table style={{ width: "100%", borderCollapse: "collapse", minWidth: "360px" }}>
              <thead>
                <tr>
                  <th style={{ ...thStyle, textAlign: "left" }}>Login Date &amp; Time</th>
                  <th style={{ ...thStyle, textAlign: "left" }}>Login Status</th>
                  <th style={{ ...thStyle, textAlign: "left" }}>IP Address</th>
                </tr>
              </thead>
              <tbody>
                {rows.length > 0 ? (
                  rows.map((r, i) => (
                    <tr key={i}>
                      <td style={{ ...tdStyle, textAlign: "left" }}>{obj.dateFormat(r?.activityDate || r?.createdAt)}</td>
                      <td style={{ ...tdStyle, textAlign: "left", color: "#1a7a1a", fontWeight: 600 }}>
                        {r?.activityStatus === "Login Success" ? "Login Successful" : r?.activityStatus}
                      </td>
                      <td style={{ ...tdStyle, textAlign: "left" }}>{r?.ip}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td style={tdStyle} colSpan={3}>
                      No data available in table
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </TableCard>
      </PageShell>
    </AccountLayout>
  );
};

export default ActivityLogNew;
